const styles = `
.be-ix-link-block{ display:inline-block;}
.be-ix-link-block .be-related-link-container .be-label {margin: 0;font-weight: 600;font-family: Montserrat;font-size:16px;}
.be-ix-link-block .be-related-link-container .be-list { display: inline-block; list-style: none;margin: 0; padding: 0;}
.be-ix-link-block .be-related-link-container .be-list .be-list-item {display: inline-block;margin-right: 20px;padding: 0;}
.be-ix-link-block .be-related-link-container .be-list .be-list-item::before {content: "";all: unset;}
.be-ix-link-block .be-related-link-container .be-label,
.be-ix-link-block .be-related-link-container .be-list .be-list-item .be-related-link{text-decoration: none;color: #fff;font-size: 16px;font-family: Montserrat;}
.be-ix-link-block .be-related-link-container .be-list .be-list-item:last-child { margin-right: 0;}
@media (max-width: 767px) {
  .be-ix-link-block .be-related-link-container{padding-top:20px;}
  .be-ix-link-block .be-related-link-container .be-label {width: 100%;margin: 0 0 1em 0;font-family: Montserrat;font-size:16px;}
  .be-ix-link-block .be-related-link-container .be-list { display: block;width: 100%;}
  .be-ix-link-block .be-related-link-container .be-list .be-list-item {display: block;margin-right: 0;}
.be-ix-link-block .be-related-link-container .be-list .be-list-item .be-related-link{text-decoration: none;line-height:20px;}
}
@media (min-width: 768px) {
  .be-ix-link-block .be-related-link-container {display: flex;align-items: baseline;justify-content: center; padding-top: 15px;}
  .be-ix-link-block .be-related-link-container .be-label {display: inline-block;margin-right: 20px;flex-grow: 0;flex-shrink: 0;}
}
`;

export function BrightEdgeContainer() {
  return (
    <>
      <div className="be-ix-link-block" />
      <style>{styles}</style>
    </>
  );
}
